import { render, staticRenderFns } from "./Section_List.vue?vue&type=template&id=71ae11e0&scoped=true&"
import script from "./Section_List.vue?vue&type=script&lang=js&"
export * from "./Section_List.vue?vue&type=script&lang=js&"
import style0 from "./Section_List.vue?vue&type=style&index=0&id=71ae11e0&scoped=true&lang=css&"
import style1 from "./Section_List.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae11e0",
  null
  
)

export default component.exports